
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextPage } from 'next';
import Head from 'next/head';
import useLocale from 'next-translate/useTranslation';
import DashboardLayout from '@/components/layout/DashboardLayout';
import ModelMultiplierTable from '@/components/ModelMultiplierTable';
import Seo from '@/components/Seo';
const ModelMultipliersPage: NextPage = () => {
    const { t } = useLocale('common');
    return (<DashboardLayout>
      <Head>
        <title>{`${t('Model Word Consumption')} | Kopi`}</title>
        <meta name='description' content={t('Learn how different AI models consume words from your subscription.')}/>
      </Head>
      <Seo />

      <main className='overflow-y-scroll'>
        <section className=' bg-white dark:bg-gray-900'>
          <div className='mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8'>
            <div className='text-center'>
              <h1 className='text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white sm:text-4xl'>
                {t('Model Word Consumption')}
              </h1>
              <p className='mx-auto mt-3 max-w-2xl text-xl text-gray-500 dark:text-gray-300 sm:mt-4'>
                {t('Learn how different AI models consume words from your subscription.')}
              </p>
            </div>

            <div className='mt-10'>
              <ModelMultiplierTable />
            </div>

            <div className='prose-primary prose mx-auto mt-10 dark:prose-invert'>
              <h2>{t('Understanding Word Consumption')}</h2>
              <p>
                {t('Each AI model has a different word consumption rate, represented by a multiplier. This multiplier affects how many words are counted against your subscription limit.')}
              </p>

              <h3>{t('What do the multipliers mean?')}</h3>
              <ul>
                <li>
                  <strong>{t('0x (Unlimited)')}</strong>:{' '}
                  {t('These models do not count against your word limit at all. You can use them as much as you want without consuming your subscription words.')}
                </li>
                <li>
                  <strong>{t('0.25x')}</strong>:{' '}
                  {t('Very efficient models. For every 4 words generated, only 1 word is counted against your limit.')}
                </li>
                <li>
                  <strong>{t('0.5x')}</strong>:{' '}
                  {t('Efficient models. For every 2 words generated, only 1 word is counted against your limit.')}
                </li>
                <li>
                  <strong>{t('0.75x')}</strong>:{' '}
                  {t('Moderately efficient models. For every 4 words generated, 3 words are counted against your limit.')}
                </li>
                <li>
                  <strong>{t('1x (Standard)')}</strong>:{' '}
                  {t('Standard consumption rate. Each word generated counts as 1 word against your limit.')}
                </li>
                <li>
                  <strong>{t('3x')}</strong>:{' '}
                  {t('Premium models with higher consumption. Each word generated counts as 3 words against your limit.')}
                </li>
              </ul>

              <h3>{t('Tips for optimizing your subscription')}</h3>
              <p>{t('To get the most out of your subscription:')}</p>
              <ul>
                <li>
                  {t("Use unlimited (0x) models for routine tasks that don't require advanced capabilities.")}
                </li>
                <li>
                  {t('Choose lower multiplier models (0.25x, 0.5x) when possible for better efficiency.')}
                </li>
                <li>
                  {t('Reserve higher multiplier models for specialized tasks that truly benefit from their advanced capabilities.')}
                </li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </DashboardLayout>);
};
export default ModelMultipliersPage;

    async function __Next_Translate__getStaticProps__1a12e86eda2__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/model-multipliers',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a12e86eda2__ as getStaticProps }
  